import { Box } from '@mui/material';
import type { FieldMode } from '../../hooks/useCaseField';
import { useCaseFieldData } from '../../hooks/useCaseField';
import { CaseTextField } from '../fields';
import type { MedNecCaseView, InsuranceDetail } from '../../../../services/MedNecService/types/medNecTypes';

interface InsuranceSectionProps {
  mode: FieldMode;
}

// Helper: read an insurance field
const ins = (field: keyof InsuranceDetail) => (d: MedNecCaseView) => (d.insurance?.[field] as string) ?? '';

// Helper: produce an update that merges a single insurance field
const insUp = (field: keyof InsuranceDetail) => (v: string, d: MedNecCaseView): Partial<MedNecCaseView> => ({
  insurance: { ...d.insurance, [field]: v },
});

const InsuranceSection: React.FC<InsuranceSectionProps> = ({ mode }) => {
  const data = useCaseFieldData(mode);
  if (!data.insurance) return null;

  return (
    <Box sx={{ mb: 2.5 }}>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1.5, mb: 1.5 }}>
        <CaseTextField mode={mode} label="Policy Number" getValue={ins('policyNumber')} getUpdate={insUp('policyNumber')} />
        <CaseTextField mode={mode} label="Group Number" getValue={ins('groupNumber')} getUpdate={insUp('groupNumber')} />
        <CaseTextField mode={mode} label="Pre-Auth Number" getValue={ins('preAuthNumber')} getUpdate={insUp('preAuthNumber')} />
        <CaseTextField mode={mode} label="WC Claim Number" getValue={ins('wcClaimNumber')} getUpdate={insUp('wcClaimNumber')} />
        <CaseTextField mode={mode} label="Relationship to Patient" getValue={ins('relationshipToPatient')} getUpdate={insUp('relationshipToPatient')} />
      </Box>
      <CaseTextField mode={mode} label="Insurance Notes" fullWidth multiline minRows={2} maxRows={6}
        getValue={ins('insuranceNotes')} getUpdate={insUp('insuranceNotes')} />
    </Box>
  );
};

export default InsuranceSection;